<template>
  <div class="">
    <farmingMapVue ref="farmingmap" @changeId="changeId"></farmingMapVue>
    <div class="bottom-tl flex justb">
      <div class="flex alit">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%9B%BE%E4%BE%8B%E5%B7%B2%E5%AE%8C%E6%88%90%402x.png"
          alt=""
        />
        已完成
      </div>
      <div class="flex alit">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%9B%BE%E4%BE%8B%E8%BF%9B%E8%A1%8C%E4%B8%AD%402x.png"
          alt=""
        />
        进行中
      </div>
      <div class="flex alit">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%9B%BE%E4%BE%8B%E6%9C%AA%E5%BC%80%E5%A7%8B%402x.png"
          alt=""
        />
        未开始
      </div>
      <div class="flex alit">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%9B%BE%E4%BE%8B%E5%B7%B2%E8%B6%85%E6%9C%9F%402x.png"
          alt=""
        />
        已超期
      </div>
    </div>
    <div class="mengban"></div>
    <div class="top-data flex justb">
      <div class="flexCol alit">
        <div class="text1">
          {{ crop.cropArea
          }}<a
            style="
              color: #ffffff;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
            "
            >(亩)</a
          >
        </div>
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%A7%8D%E6%A4%8D%E9%9D%A2%E7%A7%AF%402x.png"
          alt=""
        />
        <div class="text2">种植面积</div>
      </div>
      <div class="flexCol alit">
        <div class="text1">
          {{ crop.plotNum
          }}<a
            style="
              color: #ffffff;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
            "
            >(块)</a
          >
        </div>
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%9C%B0%E5%9D%97%E6%95%B0%E9%87%8F%402x.png"
          alt=""
        />
        <div class="text2">地块数量</div>
      </div>
      <div class="flexCol alit">
        <div class="text1">
          {{ crop.cropYield
          }}<a
            style="
              color: #ffffff;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
            "
            >(吨)</a
          >
        </div>
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E9%A2%84%E8%AE%A1%E4%BA%A7%E9%87%8F%402x.png"
          alt=""
        />
        <div class="text2">预计产量</div>
      </div>
    </div>
    <div class="back" v-if="$route.query.type == 2" @click="$router.go(-1)">
      返回
    </div>
    <div class="left noselect">
      <div class="title">农事概览</div>
      <div class="flex alit">
        <div class="task-odds flexCol alit justc">
          <div class="odds">{{ taskCount.doneRate * 100 }}%</div>
          <div class="task-title">农事任务完成率</div>
        </div>
        <div class="flexCol" style="flex: 1">
          <div class="flex justb" style="margin: 0 0 30px 40px; flex: 1">
            <div class="flexCol alit">
              <div class="ns-tt" style="color: #23ea99">已完成</div>
              <div class="ns-num">
                {{ taskCount.doneNum }} <a style="font-size: 14px">项</a>
              </div>
            </div>
            <div class="flexCol alit">
              <div class="ns-tt" style="color: #ffd725">未开始</div>
              <div class="ns-num">
                {{ taskCount.notNum }} <a style="font-size: 14px">项</a>
              </div>
            </div>
          </div>
          <div class="flex justb" style="margin: 0 0 30px 40px; flex: 1">
            <div class="flexCol alit">
              <div class="ns-tt" style="color: #eb5e00">已超期</div>
              <div class="ns-num">
                {{ taskCount.stopNum }} <a style="font-size: 14px">项</a>
              </div>
            </div>
            <div class="flexCol alit">
              <div class="ns-tt" style="color: #0083ff">进行中</div>
              <div class="ns-num">
                {{ taskCount.runNum }} <a style="font-size: 14px">项</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="title">农事任务</div>
      <div class="aifx-title flex justb alit">
        <!-- <div class="" style="width: 10%">
          <el-checkbox style="margin-left: -10px"></el-checkbox>
        </div> -->
        <div class="" style="width: 25%">任务名称</div>
        <div class="" style="width: 20%">任务类型</div>
        <div class="" style="width: 15%">状态</div>
        <div class="" style="width: 20%">日期</div>
        <div class="" style="width: 20%">负责人</div>
      </div>
      <vue-seamless-scroll
        :data="taskList"
        class="warp"
        :class-option="classOption3"
        style="overflow: hidden; margin-top: 10px"
      >
        <ul class="item" style="list-style-type: none; padding: 0">
          <li
            v-for="(item, index) in taskList"
            :key="index"
            class="flex alit"
            style="height: 36px; margin-bottom: 10px"
            :data="JSON.stringify(item)"
          >
            <div class="ai-list flex alit" style="flex: 1">
              <!-- <div class="flexCol alit" style="width: 10%">
                <el-checkbox></el-checkbox>
              </div> -->
              <div class="" style="width: 25%">
                {{ item.taskName }}
              </div>
              <div class="" style="width: 20%">
                {{ item.taskType }}
              </div>
              <div
                class=""
                style="width: 15%"
                :style="{ color: statusColor[item.status - 1] }"
              >
                {{ changeStatus(item.status) }}
              </div>
              <div class="textOne" style="width: 20%">
                <el-tooltip
                  effect="dark"
                  :content="utils.changeTimeNoHms(item.createDate)"
                  placement="top"
                >
                  <div class="">
                    {{ utils.changeTimeNoHms(item.createDate) }}
                  </div>
                </el-tooltip>
              </div>
              <div class="" style="width: 20%">
                {{ item.person }}
              </div>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll>

      <div class="time-cont">
        <div
          class="time-style"
          :style="{ color: nowCheckNs == 0 ? 'rgb(214 255 0)' : '' }"
          @click="changeNsTime(0)"
        >
          全部
        </div>
        <div
          class="time-style"
          :style="{ color: nowCheckNs == 1 ? 'rgb(214 255 0)' : '' }"
          @click="changeNsTime(1)"
        >
          今日
        </div>
        <div
          class="time-style"
          :style="{ color: nowCheckNs == 2 ? 'rgb(214 255 0)' : '' }"
          @click="changeNsTime(2)"
        >
          昨日
        </div>
        <div
          class="time-style"
          :style="{ color: nowCheckNs == 3 ? 'rgb(214 255 0)' : '' }"
          @click="changeNsTime(3)"
        >
          近一周
        </div>

        <el-popover placement="right" width="400" trigger="click">
          <el-date-picker
            v-model="nsDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeNsDate"
          >
          </el-date-picker>
          <div
            slot="reference"
            class="time-style"
            :style="{ color: nowCheckNs == 4 ? 'rgb(214 255 0)' : '' }"
          >
            自定义
          </div>
        </el-popover>
      </div>
    </div>
    <div class="right noselect">
      <div class="title flex alit">
        甘特图
        <img
          class="screen-top"
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E5%85%A8%E5%B1%8F%402x.png"
          alt=""
          @click="gttDialog = true"
        />
      </div>
      <div id="fullscreen">
        <rightTopVue v-if="!gttDialog"></rightTopVue>
      </div>
      <div class="title">农事计划</div>
      <div class="ns-plan">
        <div v-for="item in nsPlan" :key="item.title">
          <div class="set-early1 flex">
            <div
              style="
                margin-top: 5px;
                margin-left: 20px;
                color: #fab040;
                font-weight: 900;
                font-size: 16px;
                font-family: YouSheBiaoTiHei;
              "
            >
              {{ item.title }}
            </div>
          </div>
          <div class="" style="display: grid; grid-template-columns: 1fr 1fr">
            <div class="plan-left flex alit justc">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/xia%402x.png"
                style=""
                alt=""
              />
              <div class="pshuxian"></div>
            </div>
            <div class="planc">
              <div class="flex plan-cont" v-for="ite in item.content">
                <img :src="ite.icon" class="plan-icon" alt="" />
                {{ ite.cont }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 气象检测仪 -->
    <div class="dialog flexCol alit justc" v-if="gttDialog">
      <div class="mask" @click="gttDialog = false"></div>
      <div class="cont" style="background-color: #071f39; width: 95vw">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%85%B3%E9%97%AD%20%282%29.png"
          class="dialog-close"
          alt=""
          @click="gttDialog = false"
        />
        <rightTopVue></rightTopVue>
      </div>
    </div>
  </div>
</template>

<script>
import farmingMapVue from "./farmingMap.vue";
import vueSeamlessScroll from "vue-seamless-scroll";
import rightTopVue from "./rightTop.vue";
export default {
  components: {
    farmingMapVue,
    vueSeamlessScroll,
    rightTopVue,
  },
  data() {
    return {
      gttDialog: false,
      statusColor: ["#00DDA2", "#0083FF", "#FFD725", "#EB5E00"],
      nsPlan: [
        {
          title: "8月",
          content: [
            {
              icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2027%402x.png",
              cont: "水肥调控：确保抽雄至灌浆期水分供应，采用滴灌或沟灌方式，避免田间积水导致根系缺氧。喷施磷酸二氢钾等叶面肥，增强光合作用，促进籽粒饱满。",
            },
            {
              icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2025%402x.png",
              cont: "病虫害防控：针对玉米螟、叶斑病等病害，采用生物农药（如苏云金杆菌）或无人机飞防，减少化学药剂残留。清理田间变异株和杂株，保障种子纯度。",
            },
            {
              icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2027%402x%281%29.png",
              cont: "抗逆管理：对弱苗地块增施速效氮肥，避免植株早衰影响灌浆。对密植品种或高风险地块插杆加固，避免风雨造成倒伏。",
            },
          ],
        },
        {
          title: "9月",
          content: [
            {
              icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2027%402x.png",
              cont: "适时收获：优先人工掰穗（尤其是母本种子），保护胚芽完整性，确保发芽率。利用玉米联合收割机快速采收父本或大面积地块，提升效率（甘州区机械化率达74%以上）。",
            },
            {
              icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2023%402x.png",
              cont: "晾晒与干燥：在晾晒基地摊开种子，厚度不超过20厘米，每日翻动1-2次，避免霉变。遇阴雨天气启用烘干设备，将种子含水量降至14%以下。",
            },
            {
              icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2015%402x.png",
              cont: "初加工处理：使用自动化设备脱粒，按籽粒大小、密度分级，剔除破损粒。种子暂存于通风干燥库房，温度控制在≤10℃，防止虫蛀或霉变。",
            },
          ],
        },
        {
          title: "10月",
          content: [
            {
              icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2027%402x.png",
              cont: "精加工与包衣：通过风选、筛选设备去除杂质，提升种子光泽度和商品性。采用专用种衣剂（如防病、防虫、营养型）包裹种子，延长保质期。",
            },
            {
              icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2025%402x.png",
              cont: "质量检测与认证：抽检种子纯度、净度、发芽率、水分等指标，符合国家标准（如发芽率≥95%）。",
            },
            {
              icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E7%BC%96%E7%BB%84%2015%402x.png",
              cont: "仓储与销售准备：将合格种子转入恒温库（温度≤8℃），为次年销售或种植做准备。",
            },
          ],
        },
      ],
      classOption3: {
        singleHeight: 46,
        limitMoveNum: 11,
        hoverStop: true,
        waitTime: 4000,
      },
      taskList: [
        {
          title: "任务名称",
          type: "类型",
          status: "状态",
          time: "2025-12-01 16:00",
          people: "张三李四",
        },
        {
          title: "任务名称",
          type: "类型",
          status: "状态",
          time: "2025-12-01 16:00",
          people: "张三李四",
        },
        {
          title: "任务名称",
          type: "类型",
          status: "状态",
          time: "2025-12-01 16:00",
          people: "张三李四",
        },
      ],
      taskCount: {},
      crop: {},
      startTime: "",
      endTime: "",
      nsDate: [],
      nowCheckNs: 0,
    };
  },
  mounted() {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getLeftTopData();
    this.getLeftBottomData();
    this.getCenterData(this.$route.query.id ? this.$route.query.id : "");
  },
  methods: {
    changeId(e) {
      this.getCenterData(e);
    },
    screenGtt() {
      const element = document.getElementById("fullscreen"); //指定全屏区域元素
      screenfull.request(element);
      // document.getElementById("fullscreen").addEventListener("click", () => {
      //   if (screenfull.isEnabled) {
      //     screenfull.request(element);
      //   }
      // }); //实现模块全屏
    },
    changeNsDate(e) {
      this.nowCheckNs = 4;
      if (e) {
        this.startTime = this.utils.changeTimeNoHms(e[0]);
        this.endTime = this.utils.changeTimeNoHms(e[1]);
      } else {
        this.startTime = "";
        this.endTime = "";
      }
      this.getLeftBottomData();
    },
    changeNsTime(e) {
      this.nowCheckNs = e;
      const today = new Date();
      switch (e) {
        case 0:
          //今日
          this.startTime = "";
          this.endTime = "";
          this.getLeftBottomData();
          break;
        case 1:
          //今日
          this.startTime = this.utils.changeTimeNoHms(new Date());
          this.endTime = this.utils.changeTimeNoHms(new Date());
          this.getLeftBottomData();
          break;
        case 2:
          //昨日
          // 获取昨日日期
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          this.startTime = this.utils.changeTimeNoHms(yesterday);
          this.endTime = this.utils.changeTimeNoHms(yesterday);
          this.getLeftBottomData();
          break;
        case 3:
          //近一周
          // 获取昨日日期
          const weekDay = new Date(today);
          weekDay.setDate(weekDay.getDate() - 7);
          this.startTime = this.utils.changeTimeNoHms(weekDay);
          this.endTime = this.utils.changeTimeNoHms(today);
          this.getLeftBottomData();
          break;
        default:
          break;
      }
    },
    getCenterData(id) {
      this.$request(`iot/screen/plot/getCrop?id=${id}`).then((res) => {
        this.crop = res.data;
      });
    },
    getLeftTopData() {
      this.$request("iot/screen/plot/getTaskCount").then((res) => {
        this.taskCount = res.data;
      });
    },
    getLeftBottomData() {
      this.$request(
        `iot/screen/plot/listTask?startDate=${this.startTime}&endDate=${this.endTime}`
      ).then((res) => {
        this.taskList = res.data;
        setTimeout(() => {
          this.$refs.farmingmap.setMarkers(res);
        }, 1000);
      });
    },
    changeStatus(e) {
      switch (e) {
        case 1:
          return "已完成";
          break;
        case 2:
          return "进行中";
          break;
        case 3:
          return "未开始";
          break;
        case 4:
          return "已超期";
          break;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.dialog {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1500;

  .dialog-close {
    width: 30px;
    height: 30px;
    position: absolute;
    right: -30px;
    top: -30px;
    z-index: 99;
    cursor: pointer;
  }

  .mask {
    width: 100vw;
    height: 100vh;
    z-index: 1500;
    background-color: rgba(0, 0, 0, 0.9);
    position: absolute;
  }

  .cont {
    position: relative;
    z-index: 1501;
    background-color: #fff;
    border-radius: 20px;
  }
}
.back {
  width: 29px;
  height: 74px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/%E8%BF%94%E5%9B%9E%402x.png");
  background-size: 100% 100%;

  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;

  writing-mode: vertical-lr;
  /* 垂直排列，从右到左 */
  letter-spacing: 4px;
  text-align: center;
  line-height: 28px;
  letter-spacing: 5px;
  cursor: pointer;

  position: fixed;
  top: 100px;
  right: 500px;
  z-index: 99;
}
.bottom-tl {
  position: fixed;
  bottom: 30px;
  width: 20%;
  margin-left: 40%;
  z-index: 99;
  img {
    width: 15px;
    height: auto;
    margin-right: 5px;
    margin-left: 10px;
  }

  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}
.top-data {
  width: 36%;
  position: fixed;
  top: 130px;
  left: 32%;
  z-index: 99;
  .text1 {
    font-family: YouSheBiaoTiHei;
    font-size: 30px;
    color: #fab040;
    line-height: 15px;
  }
  .text2 {
    font-size: 16px;
    color: #ffffff;
    line-height: 17px;
  }
  img {
    width: 80px;
    height: 74px;
    margin-bottom: 10px;
  }
}
/* 设置滚动条整体样式 */
.ns-plan::-webkit-scrollbar {
  width: 8px;
  /* 垂直滚动条宽度 */
  height: 8px;
  /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
.ns-plan::-webkit-scrollbar-track {
  background: rgba(202, 199, 199, 0.1);
  /* 轨道背景色 */
  border-radius: 4px;
  /* 圆角 */
}

/* 设置滚动条滑块 */
.ns-plan::-webkit-scrollbar-thumb {
  background: #5d70db;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 圆角 */
}

/* 设置鼠标悬停在滑块上的样式 */
.ns-plan::-webkit-scrollbar-thumb:hover {
  background: #5166db;
  cursor: pointer;
  /* 悬停时颜色 */
}
.ns-plan {
  height: 57vh;
  overflow: auto;
  margin-top: 10px;
  .plan-left {
    height: 100%;
    position: relative;
    width: 12px;
    margin-left: 12px;
    img {
      width: 12px;
      height: 13px;
      z-index: 2;
    }
    .pshuxian {
      position: absolute;
      left: 5px;
      top: 0;
      width: 2px;
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(0, 36, 83, 0),
        rgba(0, 107, 255, 0.9)
      );
    }
  }
  .plan-icon {
    width: 24px;
    height: 24px;
    margin: 10px;
  }
  .planc {
    width: 400px;
    background: linear-gradient(
      180deg,
      rgba(200, 222, 255, 0) 0%,
      rgba(78, 158, 255, 0.28) 100%
    );
    margin-bottom: 7px;
  }
  .plan-cont {
    width: 400px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    margin-top: 20px;
    border-radius: 10px;
  }
  .set-early1 {
    width: 103px;
    height: 28px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/button%402x.png");
    background-size: 100% 100%;
    .set-early2 {
      width: 20px;
      height: 17px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E7%BC%96%E7%BB%84%402x.png");
      background-size: 100% 100%;

      margin-top: 10px;
      margin-left: 13px;
    }
  }
}

.mengban {
  position: fixed;
  z-index: 97;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E9%A6%96%E9%A1%B5%E8%83%8C%E6%99%AF%402x.png");
  background-size: 100% 100%;
}
.left {
  position: fixed;
  left: 20px;
  top: 10vh;
  width: 440px;
  height: 85vh;
  // background: rgba($color: #c8eebc, $alpha: 0.6);
  z-index: 98;
  .time-cont {
    position: fixed;
    left: 470px;
    bottom: 20px;
    .time-style {
      width: 37px;
      height: 66px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%86%9C%E4%BA%8B%E6%97%B6%E9%97%B4%E8%83%8C%E6%99%AF%402x.png");
      background-size: 100% 100%;

      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 14px;

      writing-mode: vertical-lr;
      /* 垂直排列，从右到左 */
      letter-spacing: 4px;
      text-align: center;
      line-height: 34px;
      letter-spacing: 5px;
      margin-top: 12px;
      cursor: pointer;
    }
  }

  .aifx-title {
    width: 440px;
    height: 36px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E6%A0%87%E9%A2%98%E6%A0%8F%402x.png");
    background-size: 100% 100%;

    font-weight: 500;
    font-size: 14px;
    color: #00ffd1;
    text-align: center;
  }
  .ai-list {
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
  }
  .warp {
    height: 550px;
    width: 100%;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.01);
    display: block;

    .yujing {
      width: 410px;
      height: 30px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E9%A2%84%E8%AD%A6%E8%83%8C%E6%99%AF%402x.png");
      background-size: 100% 100%;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 30px;

      // background: red;
      .yujing-type {
        width: 63px;
        height: 22px;
        background: linear-gradient(
          270deg,
          rgba(43, 85, 145, 0.5) 0%,
          rgba(30, 83, 133, 0.5) 100%
        );
        border-radius: 28px;
        border: 1px solid #0083ff;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        margin: 0 10px;

        img {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }
      }
    }

    .item {
      padding: 0;
    }

    ul {
      list-style: none;
      padding: 10px 0;
      margin: 0;
      width: 100%;
      // background-color: rgba(255, 255, 255, 0.1);

      li {
        height: 50px;
      }

      li:hover {
        background-color: #01a8ff;
      }
    }
  }
  .ns-num {
    font-family: YouSheBiaoTiHei;
    font-size: 30px;
    color: #ffffff;
  }
  .ns-tt {
    font-family: YouSheBiaoTiHei;
    font-size: 14px;
  }
  .task-odds {
    width: 141px;
    height: 169px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%86%9C%E4%BA%8B/%E5%86%9C%E4%BA%8B%E4%BB%BB%E5%8A%A1%E5%AE%8C%E6%88%90%E7%8E%87%402x.png");
    background-size: 100% 100%;
    margin: 15px 0 33px 30px;
    .odds {
      font-weight: bold;
      font-size: 24px;
      color: #ffffff;
      line-height: 128px;
      text-shadow: 0px 0px 11px rgba(31, 105, 227, 0.86);
      margin-top: -25px;
    }
    .task-title {
      font-family: YouSheBiaoTiHei;
      font-size: 17px;
      color: #ffffff;
    }
  }
}
.right {
  position: fixed;
  right: 20px;
  top: 10vh;
  width: 440px;
  height: 85vh;
  // background: rgba($color: #c8eebc, $alpha: 0.6);
  z-index: 98;
  .screen-top {
    width: 20px;
    height: 20px;
    margin-left: 10px;
    cursor: pointer;
  }
}
</style>